module.exports = __webpack_public_path__ + "img/shouye_kehu01.31c538bf.png";